import Box, { type BoxProps } from '@mui/material/Box';
import * as React from 'react';
import styled from 'styled-components';

const StyledAction = styled(Box)`
  display: flex;
  flex-flow: nowrap row;
`;

export const FormActions: React.FC<BoxProps> = ({ children }) => <StyledAction p={2}>{children}</StyledAction>;
